import { useContext, useEffect, useMemo, useState } from 'react';
import { useRemote } from '../../../Utils/Utils';
import { BannerContext } from '../../../InternalApiApp';
import AnalyticsCounter from '../../../components/Analytics/AnalyticsCounter';
import FlexWrapper from '../../FlexWrapper';
import AnalyticsExportButton from './AnalyticsExportButton';
import { analyticsExportFilename } from '../AnalyticsUtils';


const TotalMetrics = ({ data, customeDate }) => {
	const { path, counters } = data
	const { bannerAdditionalInfo } = useContext(BannerContext)
	const [analytics, setAnalytics] = useState({})
	const remote = useRemote();

	useEffect(() => {
		const products = bannerAdditionalInfo?.platforms.map(platform =>
			platform.products.map(p => p.selected ? `product=${p.id}` : null)
				.filter(e => e !== null)
				.join("&")
		)
		const query = counters.map(t => "metrics=" + t.column).join("&")
		remote.get(`${path}?${query}${products ? "&" + products : ""}`).then(setAnalytics);
	}, [bannerAdditionalInfo, counters, path, remote])

	const exportHeaders = useMemo(() => [
		{ label: 'Metric', key: 'metric' },
		{ label: 'Value', key: 'value' },
	], []);

	const exportData = useMemo(() => counters.map(c => {
		const raw = analytics[c.column];
		return {
			metric: c.label,
			value: raw === undefined || raw === null ? 0 : raw,
		};
	}), [counters, analytics]);

	const exportFilename = useMemo(
		() => analyticsExportFilename('top-portfolios', customeDate),
		[customeDate]
	);

	return (
		<>
			<FlexWrapper fullWidth justify="flex-end" className="mb-xs">
				<AnalyticsExportButton headers={exportHeaders} data={exportData} filename={exportFilename} />
			</FlexWrapper>
			<FlexWrapper fullWidth gap="xxl">
				{counters.map(c => {
					return <AnalyticsCounter key={c.label} label={c.label} count={analytics[c.column] || 0} valueStyle={c.valueStyle} labelStyle={c.labelStyle} />
				})}
			</FlexWrapper>
		</>
	);
}

export default TotalMetrics;
